import {connect} from "react-redux";
import {useEffect} from "react";

import './about.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";


import "./about.scss"
import {GetAbout} from "../../redux/actions";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import React from "react";

function About(props) {
    const {about,staticTexts} = props;
    // console.log(about,'about')

    useEffect(() => {
        props.GetAbout()
    }, [])

    return <div className={'about_wrapper'}>

        <div className={'about'}>
            <h2 className="about__title">{staticTexts?.about_page_title}</h2>
            <h2 className="about__description">{staticTexts?.about_page_description}</h2>

            <div className="about__img_fill">
                {
                    about?.mediaMain?.path ? <img src={generateFileMediaUrl(about?.mediaMain?.path)}/> : <div className={'bg_gray'}></div>
                }
            </div>

            <div className="about__content">
                <div className="about__content__left">
                    <p className="subtitle">{staticTexts?.about_page_subtitle}</p>
                    <div className="counts">
                        <div className="counts__item">
                            <span>{staticTexts?.about_page_years_count}</span>
                            <span>{staticTexts?.about_page_years_title}</span>
                        </div>
                        <div className="counts__item">
                            <span>{staticTexts?.about_page_project_count}</span>
                            <span>{staticTexts?.about_page_project_title}</span>
                        </div>
                    </div>
                </div>
                <div className={"about__content__right"} dangerouslySetInnerHTML={{__html: about?.description}}/>
            </div>
            {
                about?.medias ? <div className="about__images_wrapper">
                    <div className="left">
                        {
                            about?.medias[0]?.path ?  <img src={generateFileMediaUrl(about?.medias[0]?.path)} alt=""/> : <div className={'bg_gray'}></div>
                        }
                    </div>
                    <div className="right">
                        {
                            about?.medias[1]?.path ?  <img src={generateFileMediaUrl(about?.medias[1]?.path)} alt=""/> : <div className={'bg_gray'}></div>
                        }
                        {
                            about?.medias[2]?.path ?  <img src={generateFileMediaUrl(about?.medias[2]?.path)} alt=""/> : <div className={'bg_gray'}></div>
                        }
                    </div>
                </div> : ''
            }

        </div>
    </div>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'about',
        'staticTexts',
    ])
};
const mapDispatchToProps = {
    GetAbout};
export default connect(mapStateToProps, mapDispatchToProps)(About);
